import React from 'react'
import { getBroadcastImg } from '../../../../../Utils/EventHelpers/eventHelpers'
import { logEvent } from '../../../../../Utils/analytics/firAnalytics'
import { EventGQL } from '../../../../../Api/events/events.types'
import { BroadcastersCon } from '../../styles'
import { Img } from '../../../../Images/Img'
import { ANALYTICS_TAGS } from '../../../../../Constants/analytics'

type StatusProps = {
  event: EventGQL
}

export const Broadcasters: React.FC<React.PropsWithChildren<StatusProps>> = ({
  event,
}) => {
  return (
    <>
      {event?.broadcaster && (
        <BroadcastersCon
          href={event.urlStreaming}
          onClick={() =>
            logEvent(ANALYTICS_TAGS.boxscore_click, {
              button: 'broadcaster',
              button_text: event.broadcaster.toString(),
              section: 'game_ticker',
            })
          }
        >
          {getBroadcastImg(event.broadcaster).map((img, idx) => (
            <Img key={idx} src={img} alt={event.broadcaster[idx]} />
          ))}
        </BroadcastersCon>
      )}
    </>
  )
}
